import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=707f3cd4"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadBtn.vue?vue&type=style&index=0&id=707f3cd4&prod&lang=css"
import style1 from "./UploadBtn.vue?vue&type=style&index=1&id=707f3cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports